module.exports = __webpack_public_path__ + "static/media/stats_menu_active.c44b8a29.svg";